import React, { Component } from 'react'
import {
  Button,

  message,
} from 'antd'
import Tab from '../../components/Tab'
import Basic from './basic'
import Story from './story'
import Loader from '../../components/Loader'
import appModel from '../../model/app'
import { connect } from 'react-redux';
import { createApp, handleChangeApp, getApp, updateApp } from '../../actions/app'
import moment from 'moment'
import { FormOutlined, ReadOutlined } from '@ant-design/icons';
class ManageDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tabRoutes: [],
      tabIndex: +props.match.params.step || 0,
      text: 'No unsaved changes',
      loading: false,
      bankInfo: {},
      address: '',
      nextDone: 1,

    }
    this.id = props.match.params.id
  }

  componentWillUnmount() {
    this.props.handleChangeApp(appModel)
  }

  componentDidMount() {
    this.handleScrollTop()
    this.setTabs()
    if (this.id) {
      this.handleFetchData()
    }
  }

  handleFetchData() {
    const { getApp, history, app } = this.props
    this.setState({
      loading: true
    })
    getApp(this.id).then(result => {
      const { isSuccess, data } = result
      if (isSuccess && Object.keys(data).length) {
        const newData = {
          ...app,
          ...data,
        }

        this.props.handleChangeApp(newData)
        this.setState({
          loading: false
        })
      } else {
        message.warn("Can't get app Detail !")
        history.push('/')
      }
    })
  }

  handleScrollTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  handleSelectTab(tabIndex) {
    this.setState({ tabIndex }, () => this.setTabs())

  }

  handleChangeBank(bankInfo) {
    this.setState({
      bankInfo
    })
  }

  handleChangeLoaction(address) {
    this.setState({
      address
    }, () => {
      this.setTabs()
    })
  }

  setTabs() {
    // const { tabIndex, address, nextDone } = this.state
    // const { auth } = this.props
    // const { nickname } = auth

    const tabRoutes = [
      {
        key: 0,
        icon: <FormOutlined style={{ marginRight: '5px' }} type="form" />,
        label: 'Basic',
        component: (
          <>

            <div className="container">

              <Basic />
            </div>
          </>
        ),
      },
      {
        key: 1,
        icon: <ReadOutlined style={{ marginRight: '5px' }} type="read" />,
        label: 'Story',
        component: (
          <section className="container">
            <Story />
          </section>
        )
      },
    ]

    this.setState({ tabRoutes })
  }

  handleChangeTab() {
    let { tabIndex } = this.state
    tabIndex += 1

    if (tabIndex === 2) {
      this.setState({

        loading: true
      }, () => {
        const { createApp, app, member, updateApp } = this.props
        app.email = member.email
        app.author = member.nickname
        app.start_date = moment(app.start_date).format();
        if (this.id) {
          updateApp(this.id, app).then(result => {
            const { isSuccess, err } = result
            if (isSuccess) {
              this.props.history.push('/manage/applications')
            } else {
              message.error(err.message)
            }
          })
        } else {
          if (member.role && member.role === 'admin') {
            app.category = '0'
          } else {
            app.category = '1'
          }
          createApp(app).then(result => {
            const { isSuccess, err } = result
            if (isSuccess) {
              this.props.history.push('/manage/applications')
            } else {
              message.error(err.message)
            }
          })
        }
      })
    }
    else {
      this.setState({
        tabIndex,
      }, () => this.setTabs())
    }

  }

  handleChangeText(text) {
    let { nextDone } = this.state

    if (nextDone === 2) {
      this.setState({ loading: false })
      this.props.history.push('/manage/applications')
    }
    this.setState({
      text
    })
  }

  handleShowLoading() {
    this.setState({
      loading: true
    })
  }

  handleCloseLoading() {
    this.setState({
      loading: false
    })
  }

  render() {
    const { tabRoutes, tabIndex, loading, text } = this.state
    const nameTab = tabRoutes[tabIndex + 1] ? tabRoutes[tabIndex + 1].label : 'Done'

    return (
      <>
        <Loader show={loading}></Loader>
        <div className="manageApp">

          <Tab
            routes={tabRoutes}
            tabIndex={tabIndex}
            onSelectTab={tabIndex => this.handleSelectTab(tabIndex)}
            renderLabel={route => (
              <>
                {route.icon}
                <span style={{ marginLeft: 5 }}>{route.label}</span>
              </>
            )}
          />

          <div className="container project-flow__footer">
            <div className="project-flow__footer__text">
              {text}
            </div>
            <Button
              onClick={() => {
                this.handleChangeTab()
                this.handleScrollTop()
              }}
              style={{ backgroundColor: '#30004f', borderColor: '#30004f' }}
              type="primary"
              className="header-sticker__content__menu__button"
              shape="round"
              loading={loading}
            >
              Next:
              {' '}
              {nameTab || ''}
            </Button>
          </div>

        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  app: state.app || {},
  member: state.member || {},
});

function mapDispatchToProps() {
  return {
    createApp: (data) => createApp(data),
    handleChangeApp: (data) => handleChangeApp(data),
    getApp: (id) => getApp(id),
    updateApp: (id, data) => updateApp(id, data)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageDetail);
